const slidingText = () => {
    gsap.registerPlugin(ScrollTrigger);
    const titleRowsElements = document.querySelectorAll('.with-title-rows');

    titleRowsElements.forEach(titleRow => {
        let titleRow1 = titleRow.querySelector('.title-rows__row-1');
        if (titleRow1) {
            gsap.fromTo(titleRow1,
                {
                    x: "10%",
                },
                {
                    scrollTrigger: {
                        trigger: titleRow,
                        start: "top 80%",
                        end: "bottom 200px",
                        invalidateOnRefresh: true,
                        scrub: true,
                        markers: false,
                    },
                    x: 0,
                    ease: "none",
                    duration: 3,
                }
            );
        }

        let titleRow2 = titleRow.querySelector('.title-rows__row-2');
        if (titleRow2) {
            gsap.fromTo(titleRow2,
                {
                    x: 0,
                },
                {
                    scrollTrigger: {
                        trigger: titleRow,
                        start: "top 60%",
                        end: "bottom 200px",
                        invalidateOnRefresh: true,
                        scrub: true,
                        markers: false,
                    },
                    x: "20%",
                    ease: "none",
                    duration: 3,
                }
            );
        }

        let titleRow3 = titleRow.querySelector('.title-rows__row-3');
        if (titleRow3) {
            gsap.fromTo(titleRow3,
                {
                    x: "20%",
                },
                {
                    scrollTrigger: {
                        trigger: titleRow,
                        start: "top 80%",
                        end: "bottom 200px",
                        invalidateOnRefresh: true,
                        scrub: true,
                        markers: false,
                    },
                    x: "15%",
                    ease: "none",
                    duration: 3,
                }
            );
        }

        let titleRowSpan = titleRow.querySelector('.title-rows__row span');
        if (titleRowSpan) {
            gsap.set(titleRowSpan, {
                scrollTrigger: {
                    trigger: titleRow,
                    start: "top 50%",
                    invalidateOnRefresh: true,
                    markers: false,
                    onEnter: () => {
                        titleRowSpan.classList.add('active');
                    }
                },
                ease: "none",
                duration: 2.5,
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.with-title-rows')) {
        slidingText();
    }
});
